import {
  Storage,
} from '@intelipost-js/secure-providers';

const PageUserInformation = () => import('./PageUserInformation');
const PageUserInformationMigrated = () => import('./PageUserInformationMigrated');

const isMigrated = Storage.get('userMigrated', 'local');

export default {
  name: 'settings-user-information',
  path: 'user-information',
  component: isMigrated ? PageUserInformationMigrated : PageUserInformation,
  meta: {
    title: 'Informações do Usuário',
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/user-information/routes.js